function truncateHtmlByWords(html, maxWords) {
  var div = document.createElement('div');
  div.innerHTML = html;
  var wordCount = 0;
  var reachedLimit = false;

  console.log('hello');

  function traverse(node) {
    if (reachedLimit) return '';

    if (node.nodeType === Node.TEXT_NODE) {
      var words = node.textContent.split(/\s+/);
      if (wordCount + words.length > maxWords) {
        var remaining = maxWords - wordCount;
        reachedLimit = true;
        return words.slice(0, remaining).join(' ') + '...';
      } else {
        wordCount += words.length;
        return node.textContent;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      var result = '<' + node.nodeName.toLowerCase();
      // Copy attributes
      for (var i = 0; i < node.attributes.length; i++) {
        var attr = node.attributes[i];
        result += ' ' + attr.name + '="' + attr.value + '"';
      }
      result += '>';
      for (var j = 0; j < node.childNodes.length; j++) {
        result += traverse(node.childNodes[j]);
        if (reachedLimit) break;
      }
      result += '</' + node.nodeName.toLowerCase() + '>';
      return result;
    }
    return '';
  }

  return traverse(div);
}

function addReadMoreReadLessButton(item, truncatedText, fullText, isHTMLString) {
  const readMoreButton = document.createElement('button');
  readMoreButton.classList.add('tw-text-app-primary-blue', 'tw-ml-2', 'tw-text-sm', 'tw-underline');
  readMoreButton.textContent = 'Read more';
  
  const readLessButton = document.createElement('button');
  readLessButton.classList.add('tw-text-app-primary-blue', 'tw-ml-2', 'tw-text-sm', 'tw-underline', 'tw-hidden');
  readLessButton.textContent = 'Read less';

  readMoreButton.addEventListener('click', function() {
    if (isHTMLString) {
      item.innerHTML = fullText;
      item.appendChild(readLessButton);
    } else {
      item.textContent = fullText;
      item.appendChild(readLessButton);
    }

    readLessButton.classList.remove('tw-hidden');
    readMoreButton.classList.add('tw-hidden');
  });

  readLessButton.addEventListener('click', function() {
    if (isHTMLString) {
      item.innerHTML = truncatedText;
      item.appendChild(readMoreButton);
    } else {
      item.textContent = truncatedText;
      item.appendChild(readMoreButton);
    }

    readLessButton.classList.add('tw-hidden');
    readMoreButton.classList.remove('tw-hidden');
  });

  item.appendChild(readMoreButton);
  item.appendChild(readLessButton);
}

document.addEventListener('DOMContentLoaded', function() {
  var readMore = document.querySelectorAll('[data-read-more]');

  readMore.forEach(function(item) {
    var maxWords = item.getAttribute('data-max-words') ?? 20;

    const isHTMLString = item.children.length > 0;
    const fullText = isHTMLString ? item.innerHTML.trim() : item.textContent.trim();
    const words = fullText.split(' ');

    if (words.length <= parseInt(maxWords, 10)) return;

    if (isHTMLString) {
      // Split by HTML tags: extract text content, split by words, and reconstruct up to maxWords, preserving tags
      var truncated = truncateHtmlByWords(item.innerHTML, parseInt(maxWords, 10));
      item.innerHTML = truncated;

      addReadMoreReadLessButton(item, truncated, fullText, true);
    } else {
      item.textContent = words.slice(0, maxWords).join(' ') + '...';
      addReadMoreReadLessButton(item, item.textContent, fullText, false);
    }
  });
});
